module.exports = __webpack_public_path__ + "img/main_menu_1.49a141d6.png";